import { createFileRoute } from '@tanstack/react-router'
import { parse } from 'valibot'

import { fetchDriverUser } from '@/features/users/api'

import { userParamsSchema } from '../-models/user-params'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/drivers/$userId'
)({
  parseParams: (params) => parse(userParamsSchema, params),
  loader: async ({
    abortController,
    params: { tenantKey, userId },
    context: { auth }
  }) => {
    return {
      authUser: auth.user,
      user: await fetchDriverUser(
        {
          tenantKey,
          userId
        },
        abortController.signal
      )
    }
  },
  meta: ({ loaderData }) => [
    {
      title: loaderData.user.displayName
    }
  ]
})
